var map = {
	"./pickaxe-code.png": 621,
	"./pickaxe-plain.png": 622,
	"./pickaxe-scratch.png": 623,
	"./pickaxe-snap-classic.png": 624,
	"./pickaxe-snap.png": 625
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1520;